// @flow
import React from 'react';
import { NavLink } from 'react-router-dom';

// Подвкладки раздела «Офлайн-каттер». Отдельно от старой статистики: там свои
// цифры по вебу, здесь — только то, что прислали офлайн-приложения.
export default function OfflineTabsView() {
  return (
    <ul className="nav nav-tabs mb-3">
      <li className="nav-item">
        <NavLink to="/offline/branches/" className="nav-link" activeClassName="active">Филиалы</NavLink>
      </li>
      <li className="nav-item">
        <NavLink to="/offline/cuts/" className="nav-link" activeClassName="active">Резы</NavLink>
      </li>
      <li className="nav-item">
        <NavLink to="/offline/tokens/" className="nav-link" activeClassName="active">Токены</NavLink>
      </li>
    </ul>
  );
}
